import React, { useEffect } from "react";
import { FmText } from "../../Components";
import { TERMS_DESCRIPTION } from "../../Constants";

import useStyles from "./AboutPage.styles";

const AboutPage = () => {
    const classes = useStyles();

    return (
        <div className={classes.box}>
            <div className={classes.container}>
                <div className={classes.textContainer}>
                    <FmText variant={"large"}>About</FmText>
                    <div className={classes.descriptionContainer}>
                        <FmText>{TERMS_DESCRIPTION}</FmText>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;
